module.exports = __webpack_public_path__ + "static/media/whatsapp.7052c330.png";